import React, { useEffect, useState } from "react";
import { verifyPayment } from "./firebase/firebase";

import TopNav from "./TopNav";

export default function SuccessPage() {
  const appUrl = `blockforever-app://licenseKey?`;

  const [loading, setLoading] = useState(true);
  const [licenseKey, setLicenseKey] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Get session_id from URL
    const sessionId = new URLSearchParams(window.location.search).get(
      "session_id"
    );

    console.log(`Session Id: ${sessionId}`);

    if (sessionId && loading) {
      // Call a backend API to verify the session and get payment details
      checkPaymentStatus(sessionId);
    } else {
      setLoading(false);
      setError("Payment failed or was canceled.");
    }
  }, []);

  const checkPaymentStatus = async (sessionId) => {
    try {
      const response = await verifyPayment({ session_id: sessionId });

      console.log(response.data);

      if (response.data && response.data.success) {
        console.log("sucess");
        setLicenseKey(response.data.licenseKey);
      } else {
        setError("Payment failed or was canceled.");
        setLicenseKey(false);
      }

      setLoading(false);
    } catch (err) {
      setError("Error verifying payment.");
      setLoading(false);
      setLicenseKey(false);
    }
  };

  // open the app and pass the license key
  const openApp = () => {
    window.open(`${appUrl}${licenseKey}`, "_blank");
  };

  return (
    <div>
      <TopNav />

      <div className="flex-center mt-64">
        {loading && <p> Loading ... </p>}

        {error && <p style={{ color: "red" }}>{error}</p>}

        {licenseKey && (
          <div>
            <h1>Payment Successful!</h1>
            <p>Thank you for your payment. Your license key: {licenseKey}</p>
            <button onClick={openApp}> Open the app </button>
          </div>
        )}
      </div>
    </div>
  );
}
